import React, { useRef, useState } from "react"
import { Form, Button, Alert } from "react-bootstrap"
import { useAuth } from "../contexts/AuthContext"
import { Link, useHistory } from "react-router-dom"
import "../css/Base.css"
import Player from '../images/player.png'

export default function Login() {
  const emailRef = useRef()
  const passwordRef = useRef()
  const { login, currentUser } = useAuth()
  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)
  const history = useHistory()

  // if user is already logged in --> redirect him to his profile 
  if (currentUser != null) {
    history.push("/profile")
  }

  async function handleSubmit(e) {
    e.preventDefault()

    try {
      setError("")
      setLoading(true)
      await login(emailRef.current.value, passwordRef.current.value)

      // Check for browser support of service worker
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.register('../service-worker.js')
          .then(function (registration) {
            // Successful registration
            console.log('Hooray. Registration successful, scope is:', registration.scope);
          }).catch(function (err) {
            // Failed registration, service worker won’t be installed
            console.log('Whoops. Service worker registration failed, error:', err);
          });
      }
      history.push("/dashboard")
    } catch {
      setError("Failed to log in")
    }

    setLoading(false)
  }

  return (
    <>
      <div className="divImagePlayer">
        <img className="imagePlayer" alt="a soccerplayer" src={Player} />
      </div>
      <div className="row justify-content-md-center g-0">
        <div className="col-md-8 offset-md-1 mt-5">
          <h1 className="mt-5 mb-4 font-link-header">LOG. IN.
          </h1>
          <Form onSubmit={handleSubmit}>
            <Form.Group id="email">
              <Form.Label className="text-white" >Email</Form.Label>
              <Form.Control className="vw-35" type="email" ref={emailRef} required />
            </Form.Group>
            <Form.Group className="mt-3" id="password">
              <Form.Label className="text-white">Password</Form.Label>
              <Form.Control className="vw-35" type="password" ref={passwordRef} required />
            </Form.Group>
            <Button disabled={loading} className="vw-35 mt-4 btn-info" type="submit">
              Log In
            </Button>
          </Form>
          {error && <Alert className="mt-3 vw-35" variant="danger">{error}</Alert>}
          <div className="vw-35 text-center mt-3">
            <Link className="text-light" to="/forgot-password">Forgot Password?</Link>
          </div>
          <div className="vw-35 text-center text-light mt-2">
            Need an account? <Link className="text-light" to="/signup">Sign Up</Link>
          </div>
        </div>
      </div>
    </>
  )
}
